export const statefulKeyKey = Symbol('StatefulKey');

export function StatefulKey() {
	return function(target: any, propertyKey: string | symbol) {
		const cacheKeys = Reflect.getOwnMetadata(statefulKeyKey, target) || [];
		cacheKeys.push(propertyKey);
		Reflect.defineMetadata(statefulKeyKey, cacheKeys, target);
	};
}
